import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AppSettingsService} from '../app/appSettings.service';
import {IndicatorFilterModel} from '../../model/filter/indicatorFilterModel';
import {IndicatorResultModel} from '../../model/report/indicatorResult.model';


@Injectable()
export class  ReportService {

  private url_root: string;
  private headersConfig: HttpHeaders;

  constructor(private http: HttpClient, private settingsService: AppSettingsService) {
    this.url_root = `${settingsService.getApiAddress()}/`;
    this.headersConfig = settingsService.getHeadersConfig();
  }

  getInstanceQueueStatusPanel(filter) {
    return this.http.post(`${this.url_root}WorkflowInstanceQueue/GetInstanceQueueStatusPanel`, filter, { headers: this.headersConfig });
  }

  getGroupingIndicators(filter: IndicatorFilterModel) {
    const data = JSON.stringify({ filter });
    return this.http.post(`${this.url_root}/WorkflowIndicators/GetGroupingIndicators`, filter, { headers: this.headersConfig });
  }

  getTotalIndicators(filter: IndicatorFilterModel) {
    const data = JSON.stringify({ filter });
    return this.http.post(`${this.url_root}/WorkflowIndicators/GetTotalIndicators`, filter, { headers: this.headersConfig });
  }

  getApprovalChartValues(filter: IndicatorFilterModel) {
    const data = JSON.stringify({ filter });
    return this.http.post(`${this.url_root}/WorkflowApprovalChart/GetApprovalChartValues`, filter, { headers: this.headersConfig });
  }

  getApprovalChart(id: number) {
    const data = JSON.stringify({ id: id });
    return this.http.post(`${this.url_root}/WorkflowApprovalChart/Get`, data, { headers: this.headersConfig });
  }

}
